<template>
  <v-panel>
    <v-form ref="form" v-model="valid" >
      <div class="divider">
        <span>
          <b>Dados das Receitas - Pró-Labore</b>
        </span>
      </div>
      <v-flex md11>
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Produtor</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Retirada</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="retiradaDoProdutorMes"
              v-model="formulario.retiradaDoProdutorMes"
              type="number"
              background-color="white"
              label="R$/Mês"
              box              
            ></v-text-field>
          </v-flex>

          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Dedicação à bovinocultura</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="retiradaDoProdutorDedicacaoBovinocultura"
              v-model="formulario.retiradaDoProdutorDedicacaoBovinocultura"
              type="number"
              background-color="white"
              label="Porcentagem (%)"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Membros da família</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Retirada</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="retiradaFamiliaMes"
              v-model="formulario.retiradaFamiliaMes"
              type="number"
              background-color="white"
              label="R$/Mês"
              box              
            ></v-text-field>
          </v-flex>

          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Dedicação à bovinocultura</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="retiradaFamiliaDedicacaoBovinocultura"
              v-model="formulario.retiradaFamiliaDedicacaoBovinocultura"
              type="number"
              background-color="white"
              label="Porcentagem (%)"
              box
            ></v-text-field>
            {{form}}
          </v-flex>
        </v-layout>
      </v-flex>
    </v-form>
  </v-panel>
</template>
<script>
/* eslint-disable */
import DadosDasReceitas from "../../class/DadosDasReceitas.js";
export default {
  inject: ["$validator"],
  data: () => ({
    formulario: new DadosDasReceitas(),
    panel: [],
    lazy: true,
    valid: false,
    simulation: ''
  }),
  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    form: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        this.formulario = new DadosDasReceitas(dado.proLabore);
      });
    }
  },
  methods: {
    clear() {
      this.formulario = {
        formulario: Object.assign(this.$data, this.$options.data.apply())
      };
      this.$validator.reset();
    }
  }
};
</script>
<style scoped>
h2 {
  color: #00695c;
}

.botaoNone {
  border: solid black 1px;
  position: fixed;
  margin-bottom: 0;
  z-index: 997;
  bottom: 45px;
  right: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

@media screen and (max-width: 991px) {
  h2 {
    color: #00695c;
  }
  .container {
    position: relative;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }

  .panel {
    margin-top: 1%;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }
  .form {
    margin-top: 2%;

    min-width: 100%;
  }
  .text-field {
    background-color: blue;
    font-size: 2px;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 130%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  h2 {
    color: #00695c;
  }
  .container {
    margin-top: 2%;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }
  .panel {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }
  .panelGrafico {
    width: 70%;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }

  .button {
    float: right;
  }

  .divider {
    text-align: center;
    font-size: 180%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
  .layout {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>